"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseProductReviewPlaceholder = void 0;
/**
 * Design requests placeholder with list and paragraphs.
 * But placeholders are of type string and this function converts HTML tags to plain text equivalents.
 */
const parseProductReviewPlaceholder = text => text.replaceAll('<br>', '\n').replaceAll('<p>', '').replaceAll('</p>', '\n').replaceAll('<ul>', '').replaceAll('</ul>', '').replaceAll(/<li>(.*?)<\/li>/g, ' • $1\n').trim();
exports.parseProductReviewPlaceholder = parseProductReviewPlaceholder;
